// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xGgP","comment":"styles_comment__3wSgp"};